import React, { useState } from 'react';
import { Button, Stack } from 'react-bootstrap';
import { Add } from '@mui/icons-material';
import AddUserProject from './AddUserProject';
import { TableRefreshButton } from '../../elements/CustomButtons';

const ProjectTableAction = ({
  fetchProjectData,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <Stack direction="horizontal" gap={2}>
      <Button variant="primary" onClick={() => setOpen(true)}>
        <Add /> Add New Project
      </Button>
       <TableRefreshButton refreshData={fetchProjectData} />
      <AddUserProject fetchProjectData={fetchProjectData} setOpen={setOpen} open={open} />
    </Stack>
  );
};

export default ProjectTableAction;
